module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pane-view', {
    attrs: {
      "tools": _vm.tools
    }
  }, [_c('template', {
    slot: "search-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Search and filter",
      "tools": _vm.tools,
      "hasCloseSearchIcon": true
    }
  }), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-search-field', {
    staticClass: "pane__search-bar",
    attrs: {
      "tools": _vm.tools
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Workflow",
      "items": ['Created', 'Awaiting review', 'Awaiting approval', 'Approved', 'Submitted']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Order Status",
      "items": ['Order sent', 'Vendor confirm', 'Received', 'Routed for shelving']
    }
  }), _vm._v(" "), _c('ui-checklist', {
    attrs: {
      "title": "Payment Status",
      "items": ['No invoice', 'Created', 'Sent', 'Received', 'Approved']
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "results-pane"
  }, [_c('pane-header', {
    attrs: {
      "title": "Packages",
      "subtitle": "106 search results",
      "hasSearchIcon": true,
      "tools": _vm.tools,
      "appIconKey": "package"
    }
  }, [_c('ui-button', {
    attrs: {
      "iconLeft": "plus",
      "title": "New",
      "tools": _vm.tools
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('ui-scrollable-container', [_c('pane-content', [_c('ui-data-list', {
    attrs: {
      "preset": "package",
      "type": "results",
      "tools": _vm.tools,
      "itemCount": 106
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "preview-pane"
  }, [_c('pane-preview-container', {
    attrs: {
      "tools": _vm.tools
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3df9b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PackagesView.vue
// module id = 444
// module chunks = 1